import React from 'react'

// import layout
import Layout from './shared/components/Layout'

// Menu icons
import { MainMenuIcons } from './shared/elements/icons'

// import pages
import NoMatch from './pages/NoMatch'

// Auth
import Login from './pages/Login'
import ChangePass from './pages/Auth/ChangePass'
import ChangePin from './pages/Auth/ChangePin'
import ResetPassword from './pages/PasswordReset'

// Activation
import Activate from './pages/Activate'

// Signup
import Signup from './pages/Signup'

// Workscreen
import Workscreen from './pages/NewWorkscreen'

// PunchClock
import PunchClock from './pages/PunchClock'

// PunchReport
import PunchReport from './pages/PunchReport'

// PunchEdit
import PunchEdit from './pages/PunchEdit'

// AbsenceReport
import AbsenceReport from './pages/AbsenceReport'

// Dashboard
import Dashboard from './pages/Dashboard'

// Price calculation
import PriceCalculation from './pages/PriceCalculation'

// Conflicts
import Conflicts from './pages/Conflicts'

// Orders
import Order from './pages/Orders/Order'
import OrderList from './pages/Orders/OrderList'
import OrderInspection from './pages/Orders/OrderInspection'

// Addresses
import Addresses from './pages/Addresses'

// Prices
import Prices from './pages/Prices'

// PriceApproval
import PriceApproval from './pages/PriceApproval'

// Quality check Settings
import QualityCheckSettings from './pages/QualityCheckSettings'
import QualityCheckSettingsChild from './pages/QualityCheckSettings/QualityCheckSettingsChild'

// Settings
import Settings from './pages/Settings'
import Invoicing from './pages/Settings/Invoicing'

// Chains
import Chains from './pages/Chains'

// Performance
import Performance from './pages/Performance'

// Forsilist
import ForsiList from './pages/ForsiList'

// InsuranceCompanyList
import InsuranceCompanyList from './pages/InsuranceCompanyList'

// Shop owner
import SelectShop from './pages/SelectShop'

// My page
import MyPage from './pages/MyPage'
import MyOrders from './pages/MyPage/MyOrders'
import MyOrdersOrder from './pages/MyPage/MyOrders/Order'
import MyTasks from './pages/MyPage/MyTasks'
import MyTasksTask from './pages/MyPage/MyTasks/Task'
import MyMessages from './pages/MyPage/MyMessages'
import MyMessagesMessage from './pages/MyPage/MyMessages/Message'

// Customers
import Customers from './pages/Customers'
import CustomersContacts from './pages/Customers/Contacts'
import SingleCustomer from './pages/Customers/Single'

// CollaboratingPartners
import CollaboratingPartners from './pages/CollaboratingPartners'

// Employees
import Employees from './pages/Employees'

// Shop Owners
import ShopOwners from './pages/ShopOwners'

// Shops
import Shops from './pages/Shops'

// Small Dashboard
import SmallDashboard from './pages/SmallDashboard'
import DataWarehouse from './pages/DataWarehouse'

// Partners
import Partners from './pages/Partners'
import PartnerContacts from './pages/Partners/Contacts'
import PartnerConstraints from './pages/Partners/Constraints'

// Evaluation history
import EvaluationHistory from './pages/EvaluationHistory'

// Price agreements
// import PriceAgreements from './pages/PriceAgreements'
import Agreements from './pages/PriceAgreements/Agreements'

// Customer groups
import CustomerGroups from './pages/CustomerGroups'
import CustomerGroupContacts from './pages/CustomerGroups/Contacts'

// CarRental
import CarRental from './pages/CarRental'
import CarRentals from './pages/CarRentals'

// Manager
import Managers from './pages/Managers'

// Tasks
import Task from './pages/Tasks/Task'
import Tasks from './pages/Tasks'

// Messages
import Messages from './pages/Messages'
import Message from './pages/Messages/Message'

// Subcontractors
import Subcontractors from './pages/Subcontractors'

// Spare parts supplier
import SparePartSuppliers from './pages/SparePartsSuppliers'

// Overview
import ProductionStatusOverview from './shared/components/ProductionStatusOverview'
import DeliveryStatusOverview from './shared/components/DeliveryStatusOverview'

// Embedded booking
import EmbeddedBooking from './pages/EmbeddedBooking'

// Car owner portal
import CarOwnerPortal from './pages/CarOwnerPortal'

import IntegrationErrorList from './pages/IntegrationErrorList'

// Support
import SupportAccessUser from './pages/SupportAccessUser'

// ESG
import ESGChain from './pages/ESG/Chain'
import ESGCompany from './pages/ESG/Company'

import axios from 'axios'

// EmptyPage
class EmptyPage extends React.Component {
  render () { return null }
}

// Require auth to show layout
import requireAuth from './utils/requireAuth'
import { hasAccess, hasDepartmentType, isLoginFromShop } from './utils/auth'

export default (store) => {
  // On Enter
  const onEnter = (nextState, replace, callback) => {
    const state = store.getState()

    let origin = window.location.origin
    let url = origin + '/version.json'
    let serverVer = ''
    let serverBuild = ''
    let clientBuild = window.localStorage.getItem('clientBuild')
    let clientVer = window.localStorage.getItem('clientVersion')

    // Stop caching the version file!
    const config = {
      headers: {
        Pragma: 'no-cache',
        'Expires': '-1'
      }
    }

    axios.get(url, config).then((res) => {
      let version = res.data
      serverVer = version.version
      serverBuild = version.build
      if (clientBuild === undefined || clientBuild === 'undefined' || clientBuild === 'null' || clientBuild === null) {
        window.localStorage.setItem('clientBuild', serverBuild)
        window.localStorage.setItem('clientVersion', serverVer)
        clientBuild = serverBuild
        clientVer = serverVer
      }
      if (clientBuild !== serverBuild || clientVer !== serverVer) {
        window.localStorage.setItem('clientBuild', serverBuild)
        window.localStorage.setItem('clientVersion', serverVer)
        window.location.reload()
      }
    })

    // console.log('usertype', state.auth.user.UserType)
    // console.log('Console test')
    // if (nextState.routes[nextState.routes.length - 1].allowExternalAccess) {
    //   // replace({ nextPathname: nextState.location.pathname }, '/')
    //   callback()
    //   console.log('Console test 2')
    //   return
    // }
    if (typeof state.auth.user.UserType === 'undefined') {
      replace({ nextPathname: nextState.location.pathname }, '/login')
    } else {
      let access = nextState.routes[nextState.routes.length - 1].access
      let hasValidShops = nextState.routes[nextState.routes.length - 1].hasValidShop
      let ValidShopChecks = nextState.routes[nextState.routes.length - 1].ValidShopCheck
      let isValidShop = true
      let userType = state.auth.user.UserType
      if (nextState.location.pathname.indexOf('/orders/') === -1 && isLoginFromShop(state.auth.inactiveUsers)) {
        // if you logged in as a shop, you shouldn't be able to get an employees rights
        userType = 5
      }
      if (hasValidShops !== undefined && hasValidShops.length > 0) {
        isValidShop = hasDepartmentType(state.auth, hasValidShops, userType, ValidShopChecks)
      }
      // let permissionId = nextState.routes[nextState.routes.length - 1].permissionId
      // if (permissionId === undefined || permissionId === null) permissionId = 0
      // let availableFree = nextState.routes[nextState.routes.length - 1].isAvailableFree
      if (!hasAccess(access, userType) || !isValidShop) { // || !hasPermission(state.auth, permissionId, availableFree)
        replace({ nextPathname: nextState.location.pathname }, '/')
      }
    }
    callback()
  }
  // Return routes
  return [
    {
      path: '/login',
      component: Login,
      isAvailableFree: true
    },
    {
      path: '/resetpassword',
      component: ResetPassword,
      isAvailableFree: true
    },
    {
      path: '/resetpassword/:resetToken',
      component: ResetPassword,
      isAvailableFree: true
    },
    {
      path: '/signup',
      component: Signup,
      isAvailableFree: true
    },
    {
      path: '/activate/:activationCode',
      component: Activate,
      isAvailableFree: true
    },
    {
      path: '/activate/',
      component: Activate,
      isAvailableFree: true
    },
    {
      path: '/priceapproval/:approvalToken',
      component: PriceApproval,
      isAvailableFree: true
    },
    {
      path: '/embeddedbooking/:embedToken/:language',
      component: EmbeddedBooking
    },
    {
      path: '/carownerportal/:token',
      component: CarOwnerPortal
    },
    {
      path: '/empty',
      component: EmptyPage,
      isAvailableFree: true
    },
    {
      path: '/',
      component: requireAuth(Layout),
      isAvailableFree: true,
      indexRoute: {
        component: Dashboard
      },
      childRoutes: [
        {
          path: '/selectshop',
          component: SelectShop,
          onEnter: onEnter,
          access: [8],
          isAvailableFree: false,
          topBar: {
            title: 1896,
            icon: MainMenuIcons.WorkScreen_White
          },
          menu: {
            order: 1,
            title: '1896',
            icon: MainMenuIcons.WorkScreen_Black
          }
        },
        {
          path: '/workscreen',
          component: Workscreen,
          onEnter: onEnter,
          access: [3, 5, 7],
          isAvailableFree: true,
          permissionId: 1,
          topBar: {
            title: 18,
            icon: MainMenuIcons.WorkScreen_White
          },
          menu: {
            order: 4,
            title: '18',
            icon: MainMenuIcons.WorkScreen_Black
          }
        },
        {
          path: '/orders',
          component: OrderList,
          onEnter: onEnter,
          access: [3, 4, 6, 7],
          isAvailableFree: true,
          topBar: {
            title: 14876,
            icon: MainMenuIcons.OrderList_White
          },
          menu: {
            order: 3,
            title: '14876',
            icon: MainMenuIcons.OrderList_Black
          }
        },
        {
          path: '/orders/:orderID',
          component: Order,
          onEnter: onEnter,
          access: [3, 4, 6, 7],
          isAvailableFree: true
        },
        {
          path: '/orders/:orderID/orderinspection',
          component: OrderInspection,
          onEnter: onEnter,
          access: [3, 4, 6, 7],
          isAvailableFree: false
        },
        {
          path: '/pricecalculation/:orderID/:addon',
          component: PriceCalculation,
          isAvailableFree: true
        },
        {
          path: '/evaluationhistory/:orderId',
          component: EvaluationHistory,
          onEnter: onEnter,
          access: [3, 5, 7, 6],
          isAvailableFree: false
          // menu: {
          //   order: 200,
          //   title: 'Eval hist. (dev)',
          //   icon: '/images/icons/menu/Workscreen-Black.png'
          // }
        },
        {
          path: '/addresses',
          component: Addresses,
          onEnter: onEnter,
          access: [3, 4, 7],
          ValidShopCheck: [3],
          hasValidShop: [1, 2],
          isAvailableFree: false,
          subscriptionValue: 20,
          checkPartnerSubscription: true,
          topBar: {
            title: 13466,
            icon: MainMenuIcons.Adresses_White
          },
          menu: {
            order: 10,
            title: '13466',
            icon: MainMenuIcons.Adresses_Black
          }
        },
        {
          path: '/prices',
          component: Prices,
          onEnter: onEnter,
          access: [2, 3, 4, 6, 7],
          isAvailableFree: true,
          permissionId: 11,
          subscriptionValue: 20,
          customer: false,
          topBar: {
            title: 1172,
            icon: MainMenuIcons.PriceLists_White
          },
          menu: {
            order: 5,
            title: '1172',
            icon: MainMenuIcons.PriceLists_Black
          }
        },
        {
          path: '/prices/:type',
          component: Prices,
          onEnter: onEnter,
          access: [2, 3, 4, 6, 7],
          permissionId: 11,
          customer: false,
          isAvailableFree: true
        },
        {
          path: '/prices/:type/:value',
          component: Prices,
          onEnter: onEnter,
          access: [2, 3, 4, 6, 7],
          permissionId: 11,
          customer: false,
          isAvailableFree: true
        },
        {
          path: '/qualitychecksettings',
          component: QualityCheckSettings,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false,
          subscriptionValue: 30,
          permissionId: 22,
          topBar: {
            title: (department) => department === 1 ? 17893 : 13421,
            icon: MainMenuIcons.QualityCheck_White
          },
          menu: {
            order: 6,
            title: (department) => department === 1 ? '17893' : '13421',
            icon: MainMenuIcons.QualityCheck_Black
          },
          childRoutes: [
            {
              path: ':type',
              component: QualityCheckSettingsChild,
              onEnter: onEnter,
              access: [2, 3, 7],
              isAvailableFree: false
            }
          ]
        },
        // Chain admin page (chain users does not have permissions, to handle without permissions)
        // {
        //   path: '/qualitychecksettings',
        //   component: QualityCheckSettings,
        //   onEnter: onEnter,
        //   access: [2],
        //   isAvailableFree: false,
        //   menu: {
        //     order: 6,
        //     title: '13421',
        //     icon: '/images/icons/menu/qualitycontrol-Black.png'
        //   },
        //   childRoutes: [
        //     {
        //       path: ':type',
        //       component: QualityCheckSettingsChild,
        //       onEnter: onEnter,
        //       access: [2, 3, 7],
        //       isAvailableFree: false
        //     }
        //   ]
        // },
        {
          path: '/settings',
          component: Settings,
          onEnter: onEnter,
          access: [2, 3, 7],
          permissionId: [6, 11, [12, 19], 22],
          isAvailableFree: true,
          topBar: {
            title: 6,
            icon: MainMenuIcons.Settings_White
          },
          menu: {
            order: 150,
            title: '6',
            icon: MainMenuIcons.Settings_Black
          }
        },
        {
          path: '/settings/:type',
          component: Settings,
          onEnter: onEnter,
          access: [2, 3, 7],
          isAvailableFree: true,
          topBar: {
            title: 6,
            icon: MainMenuIcons.Settings_White
          }
        },
        {
          path: '/conflicts',
          component: Conflicts,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false,
          topBar: {
            title: 12304,
            icon: MainMenuIcons.Settings_White
          },
          menu: {
            order: 150,
            title: '12304',
            icon: MainMenuIcons.Settings_Black
          }
        },
        {
          path: '/conflicts/:customerId',
          component: Conflicts,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false
        },
        {
          path: '/wpemployees',
          component: PartnerContacts,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false,
          topBar: {
            title: 10,
            icon: MainMenuIcons.Employees_White
          },
          menu: {
            order: 160,
            title: '10',
            icon: MainMenuIcons.Employees_Black
          }
        },
        {
          path: '/forsilist',
          component: ForsiList,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false,
          topBar: {
            title: 2228,
            icon: MainMenuIcons.Forsi_White
          },
          menu: {
            order: 10,
            title: '2228',
            icon: MainMenuIcons.Forsi_Black
          }
        },
        {
          path: '/insurancecompanylist',
          component: InsuranceCompanyList,
          onEnter: onEnter,
          access: [2, 3, 7, 8],
          isAvailableFree: false,
          permissionId: 11,
          subscriptionValue: 10,
          topBar: {
            title: 13044,
            icon: MainMenuIcons.Insurance_White
          },
          menu: {
            order: 7,
            title: '13044',
            icon: MainMenuIcons.Insurance_Black
          }
        },
        {
          path: '/chains',
          component: Chains,
          onEnter: onEnter,
          access: [1],
          isAvailableFree: false,
          topBar: {
            title: 1700,
            icon: MainMenuIcons.Chain_White
          },
          menu: {
            order: 1,
            title: '1700',
            icon: MainMenuIcons.Chain_Black
          }
        },
        {
          path: '/chains/:type',
          component: Chains,
          onEnter: onEnter,
          access: [1],
          isAvailableFree: false
        },
        {
          path: '/chains/:chainID/managers',
          component: Managers,
          onEnter: onEnter,
          access: [1],
          isAvailableFree: false
        },
        {
          path: '/chains/:chainID/managers/:managerID',
          component: Managers,
          onEnter: onEnter,
          access: [1],
          isAvailableFree: false
        },
        {
          path: '/performance',
          component: Performance,
          onEnter: onEnter,
          access: [1],
          isAvailableFree: false,
          topBar: {
            title: 18369,
            icon: MainMenuIcons.Forsi_White
          },
          menu: {
            order: 2,
            title: 18369,
            icon: MainMenuIcons.Forsi_Black
          }
        },
        {
          path: '/customers',
          component: Customers,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: true,
          permissionId: 7,
          topBar: {
            title: 14,
            icon: MainMenuIcons.Customers_White
          },
          menu: {
            order: 8,
            title: '14',
            icon: MainMenuIcons.Customers_Black
          }
        },
        {
          path: '/customers/:customerID',
          component: SingleCustomer,
          onEnter: onEnter,
          access: [0],  // 4 - HUSK: reinsert
          isAvailableFree: true,
          permissionId: 7,
          topBar: {
            title: 700,
            icon: MainMenuIcons.Settings_White
          },
          menu: {
            order: 100,
            title: '700',
            icon: MainMenuIcons.Settings_Black,
            parser: (user, link) => {
              return link.replace(':customerID', user.CustomerId)
            }
          }
        },
        {
          path: '/customers/:customerID/contacts',
          component: CustomersContacts,
          onEnter: onEnter,
          access: [3, 4, 7],
          isAvailableFree: true,
          topBar: {
            title: 13460,
            icon: MainMenuIcons.Customers_White
          },
          menu: {
            order: 4,
            title: '13460',
            icon: MainMenuIcons.Customers_Black,
            access: [0],  // 4 - HUSK: reinsert
            parser: (user, link) => {
              return link.replace(':customerID', user.CustomerId)
            }
          }
        },
        {
          path: '/customers/:customerID/contacts/:contactID',
          component: CustomersContacts,
          onEnter: onEnter,
          access: [3, 4, 7],
          isAvailableFree: true,
          topBar: {
            title: 13460,
            icon: MainMenuIcons.Customers_White
          }
        },
        {
          path: '/customers/:customerID/prices',
          component: Prices,
          onEnter: onEnter,
          access: [3, 7],
          customer: true,
          isAvailableFree: true,
          topBar: {
            title: 1172,
            icon: MainMenuIcons.PriceLists_White
          }
        },
        {
          path: '/customers/:customerID/prices/:type',
          component: Prices,
          onEnter: onEnter,
          access: [3, 7],
          customer: true,
          isAvailableFree: true,
          topBar: {
            title: 1172,
            icon: MainMenuIcons.PriceLists_White
          }
        },
        {
          path: '/customers/:customerID/prices/:type/:value',
          component: Prices,
          onEnter: onEnter,
          access: [3, 7],
          customer: true,
          isAvailableFree: true,
          topBar: {
            title: 1172,
            icon: MainMenuIcons.PriceLists_White
          }
        },
        {
          path: '/customers/:customerID/prices/:type/:value/:separateType',
          component: Prices,
          onEnter: onEnter,
          access: [3, 7],
          customer: true,
          isAvailableFree: true,
          topBar: {
            title: 1172,
            icon: MainMenuIcons.PriceLists_White
          }
        },
        {
          path: '/employees',
          component: Employees,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: true,
          permissionId: 9,
          topBar: {
            title: 10,
            icon: MainMenuIcons.Employees_White
          },
          menu: {
            order: 11,
            title: '10',
            icon: MainMenuIcons.Employees_Black
          }
        },
        {
          path: '/shops',
          component: Shops,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: true,
          topBar: {
            title: 1861,
            icon: MainMenuIcons.Shops_White
          },
          menu: {
            order: 13,
            title: '1861',
            icon: MainMenuIcons.Shops_Black
          }
        },
        {
          path: '/smalldashboard',
          component: SmallDashboard,
          onEnter: onEnter,
          access: [3, 7],
          ValidShopCheck: [3, 7],
          isAvailableFree: false,
          hasValidShop: [0, 1, 2],
          subscriptionValue: 30,
          permissionId: 10,
          topBar: {
            title: 389,
            icon: MainMenuIcons.Statistics_White
          },
          menu: {
            order: 14,
            title: '389',
            icon: MainMenuIcons.Statistics_Black
          }
        },
        {
          path: '/datawarehouse/:reportType',
          component: DataWarehouse,
          onEnter: onEnter,
          access: [3, 7],
          ValidShopCheck: [3, 7],
          isAvailableFree: false,
          hasValidShop: [0, 1, 2],
          subscriptionValue: 30,
          permissionId: 10,
          topBar: {
            title: 389,
            icon: MainMenuIcons.Statistics_White
          }
        },
        {
          path: '/shopowners',
          component: ShopOwners,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false,
          topBar: {
            title: 1860,
            icon: MainMenuIcons.Customers_White
          },
          menu: {
            order: 12,
            title: '1860',
            icon: MainMenuIcons.Customers_Black
          }
        },
        {
          path: '/managers',
          component: Managers,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false,
          topBar: {
            title: 1862,
            icon: MainMenuIcons.Customers_White
          },
          menu: {
            order: 14,
            title: '1862',
            icon: MainMenuIcons.Customers_Black
          }
        },
        {
          path: '/partners/:partnerID',
          component: Partners,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false,
          topBar: {
            title: 1879,
            icon: MainMenuIcons.Partners_White
          }
        },
        {
          path: '/partners',
          component: Partners,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false,
          topBar: {
            title: 1879,
            icon: MainMenuIcons.Partners_White
          },
          menu: {
            order: 2,
            title: '1879',
            icon: MainMenuIcons.Partners_Black
          }
        },
        {
          path: '/invoicing',
          component: Invoicing,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false,
          topBar: {
            title: 13486,
            icon: MainMenuIcons.Partners_White
          },
          menu: {
            order: 18,
            title: '13486',
            icon: MainMenuIcons.Partners_Black
          }
        },
        {
          path: '/partners/:partnerID/contacts',
          component: PartnerContacts,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false
        },
        {
          path: '/partners/:partnerID/contacts/:contactID',
          component: PartnerContacts,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false
        },
        {
          path: '/partners/:partnerID/constraints',
          component: PartnerConstraints,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false
        },
        {
          path: '/partners/:partnerID/constraints/:ConstraintID',
          component: PartnerConstraints,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false
        },
        {
          path: '/partners/:partnerID/prices',
          component: Prices,
          onEnter: onEnter,
          access: [2],
          partners: true,
          isAvailableFree: false
        },
        {
          path: '/partners/:partnerID/prices/:type',
          component: Prices,
          onEnter: onEnter,
          access: [2],
          partners: true,
          isAvailableFree: false
        },
        /* {
          path: '/priceagreements',
          component: PriceAgreements,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false,
          menu: {
            order: 4,
            title: 'Constraints @',
            icon: '/images/icons/menu/Partners-Black.png'
          }
        },
        {
          path: '/priceagreements/:ConstraintID',
          component: PriceAgreements,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false
        }, */
        {
          path: '/agreements',
          component: Agreements,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false,
          topBar: {
            title: 12309,
            icon: MainMenuIcons.Partners_White
          },
          menu: {
            order: 2,
            title: '12309',
            icon: MainMenuIcons.Partners_Black
          }
        },
        {
          path: '/agreements/:type',
          component: Agreements,
          onEnter: onEnter,
          access: [6],
          permissionId: 11,
          customer: false,
          isAvailableFree: false,
          topBar: {
            title: 12309,
            icon: MainMenuIcons.Partners_White
          }
        },
        {
          path: '/customergroups/:customerGroupId',
          component: CustomerGroups,
          onEnter: onEnter,
          access: [2, 6],
          isAvailableFree: false,
          topBar: {
            title: 12308,
            icon: MainMenuIcons.Partners_White
          }
        },
        {
          path: '/customergroups',
          component: CustomerGroups,
          onEnter: onEnter,
          access: [2, 6],
          isAvailableFree: false,
          topBar: {
            title: 12308,
            icon: MainMenuIcons.Partners_White
          },
          menu: {
            order: 3,
            title: '12308',
            icon: MainMenuIcons.Partners_Black
          }
        },
        {
          path: '/customergroups/:customerGroupID/contacts',
          component: CustomerGroupContacts,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false
        },
        {
          path: '/customergroups/:customerGroupID/contacts/:contactID',
          component: CustomerGroupContacts,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false
        },
        {
          path: '/Subcontractors',
          component: Subcontractors,
          onEnter: onEnter,
          access: [6],
          isAvailableFree: false,
          topBar: {
            title: 1737,
            icon: MainMenuIcons.Subcontractors_White
          },
          menu: {
            order: 9,
            title: '1737',
            icon: MainMenuIcons.Subcontractors_Black
          }
        },
        // {
        //   path: '/manualupdate/:orderID',
        //   component: ManualUpdate,
        //   onEnter: onEnter,
        //   access: [3, 7],
        //   isAvailableFree: true,
        //   topBar: {
        //     title: 1789,
        //     icon: HeaderIcons.Update_White
        //   }
        // },
        {
          path: '/supportaccess',
          component: SupportAccessUser,
          access: [3],
          topBar: {
            title: 17967,
            icon: MainMenuIcons.Employees_White
          }
        },
        {
          path: '/changepassword',
          component: ChangePass,
          isAvailableFree: true
        },
        {
          path: '/changepin',
          component: ChangePin,
          access: [3],
          isAvailableFree: true,
          topBar: {
            title: 17961, // TODO: state.auth.user.UserHasPincode ? 17961 : 17977
            icon: MainMenuIcons.PasswordChange_White
          }
        },
        {
          path: '/tasks',
          component: Tasks,
          onEnter: onEnter,
          access: [2, 3, 7],
          isAvailableFree: false,
          subscriptionValue: 30,
          permissionId: 14,
          topBar: {
            title: 1227,
            icon: MainMenuIcons.Tasks_White
          },
          menu: {
            order: 16,
            title: '1227',
            icon: MainMenuIcons.Tasks_Black
          }
        },
        {
          path: '/tasks/:tasksID',
          component: Task,
          onEnter: onEnter,
          access: [2, 3, 7],
          isAvailableFree: false,
          topBar: {
            title: 1227,
            icon: MainMenuIcons.Tasks_White
          }
        },
        {
          path: '/messages',
          component: Messages,
          onEnter: onEnter,
          access: [2, 3, 7],
          isAvailableFree: false,
          subscriptionValue: 30,
          permissionId: 8,
          topBar: {
            title: 1243,
            icon: MainMenuIcons.Messages_White
          },
          menu: {
            order: 16,
            title: '1243',
            icon: MainMenuIcons.Messages_Black
          }
        },
        {
          path: '/messages/:messagesID',
          component: Message,
          onEnter: onEnter,
          access: [2, 3, 7],
          isAvailableFree: false,
          topBar: {
            title: 1243,
            icon: MainMenuIcons.Messages_White
          }
        },
        {
          path: '/punchclock',
          component: PunchClock,
          onEnter: onEnter,
          access: [3, 5, 7],
          isAvailableFree: false,
          subscriptionValue: 20,
          permissionId: 12,
          topBar: {
            title: 437,
            icon: MainMenuIcons.PunchClock_White
          },
          menu: {
            order: 12,
            title: '437',
            icon: MainMenuIcons.PunchClock_Black
          }
        },
        {
          path: '/punchreport',
          component: PunchReport,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false,
          subscriptionValue: 20,
          permissionId: 16,
          onlyDev: false,
          topBar: {
            title: 2241,
            icon: MainMenuIcons.HourReport_White
          },
          menu: {
            order: 13,
            title: '2241',
            icon: MainMenuIcons.HourReport_Black
          }
        },
        {
          path: '/punchedit',
          component: PunchEdit,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false,
          permissionId: 12,
          onlyDev: false
          // menu: {
          //   title: 'Punch edit @',
          //   icon: '/images/icons/punch-black-30.png'
          // }
        },
        {
          path: '/absencereport',
          component: AbsenceReport,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false
        },
        {
          path: '/mypage',
          component: MyPage,
          indexRoute: {
            component: MyOrders
          },
          access: [3],
          isAvailableFree: true,
          childRoutes: [
            {
              path: 'orders',
              component: MyOrders,
              isAvailableFree: true,
              topBar: {
                title: 1887
              },
              childRoutes: [
                {
                  path: ':orderID',
                  component: MyOrdersOrder,
                  isAvailableFree: true
                }
              ]
            },
            {
              path: 'tasks',
              component: MyTasks,
              isAvailableFree: false,
              topBar: {
                title: 1887
              },
              childRoutes: [
                {
                  path: ':taskID',
                  component: MyTasksTask,
                  isAvailableFree: false
                }
              ]
            },
            {
              path: 'messages',
              component: MyMessages,
              isAvailableFree: false,
              topBar: {
                title: 1887
              },
              childRoutes: [
                {
                  path: ':msgID',
                  component: MyMessagesMessage,
                  isAvailableFree: false
                }
              ]
            }
          ]
        },
        {
          path: '/CarRental', // Should only be shown for companies that does not have access to the Overview
          component: CarRental,
          access: [3, 7],
          isAvailableFree: false,
          permissionId: 11, // 11: "Shop 1", 29: "Rental car overview"
          subscriptionValue: 10,
          // maxSubscriptionValue: 20,
          exclPermissionId: 29,   // Excl. when access to overview
          topBar: {
            title: 14778,
            icon: MainMenuIcons.CarRental_White
          },
          menu: {
            order: 11,
            title: '14778',
            icon: MainMenuIcons.CarRental_Black
          }
        },
        {
          path: '/CarRentals/Overview',
          component: CarRentals,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false,
          permissionId: 29,
          subscriptionValue: 20,
          topBar: {
            title: 15105,
            icon: MainMenuIcons.CarRental_White
          },
          menu: {
            order: 4,
            title: '15105',
            icon: MainMenuIcons.CarRental_Black
          }
        },
        {
          path: '/collaboratingPartners',
          component: CollaboratingPartners,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false,
          permissionId: 29,
          subscriptionValue: 20,
          ValidShopCheck: [3, 7],
          hasValidShop: [1, 2],
          checkAuth: (auth) => { return auth.permissions.IsCollaboratingPartnersAvailable },
          topBar: {
            title: 17906,
            icon: MainMenuIcons.CollaboratingPartners_White
          },
          menu: {
            order: 8,
            title: '17906',
            icon: MainMenuIcons.CollaboratingPartners_Black
          }
        },
        {
          path: '/sparepartsuppliers',
          component: SparePartSuppliers,
          onEnter: onEnter,
          access: [3, 7],
          permissionId: 31,
          isAvailableFree: false,
          subscriptionValue: 30,
          ValidShopCheck: [3, 7],
          hasValidShop: [1, 2],
          topBar: {
            title: 16424,
            icon: MainMenuIcons.SpareParts_White
          },
          menu: {
            order: 8,
            title: '16506',
            icon: MainMenuIcons.SpareParts_Black
          },
          childRoutes: [
            {
              path: ':supplierID',
              component: SparePartSuppliers
            }
          ]
        },
        {
          path: '/productionstatus',
          component: ProductionStatusOverview,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false,
          subscriptionValue: 30,
          topBar: {
            title: '16599'
          }
        },
        {
          path: '/deliverystatus',
          component: DeliveryStatusOverview,
          onEnter: onEnter,
          access: [3, 7],
          isAvailableFree: false,
          subscriptionValue: 30,
          topBar: {
            title: 16599
          }
        },
        {
          path: '/integrationerrorlist',
          component: IntegrationErrorList,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false,
          topBar: {
            title: 18163,
            icon: MainMenuIcons.Forsi_White
          },
          menu: {
            order: 11,
            title: 18163,
            icon: MainMenuIcons.Forsi_Black
          }
        },
        {
          path: '/chainesg',
          component: ESGChain,
          onEnter: onEnter,
          access: [2],
          isAvailableFree: false,
          topBar: {
            title: 18401,
            icon: MainMenuIcons.Statistics_White
          },
          menu: {
            order: 17,
            title: 18401,
            icon: MainMenuIcons.Statistics_Black
          },
          childRoutes: [
            {
              path: ':chemaId',
              component: ESGChain
            }
          ]
        },
        {
          path: '/esg',
          component: ESGCompany,
          onEnter: onEnter,
          access: [7, 3], // owners and employees
          permissionId: 11,
          isAvailableFree: false,
          checkAuth: (auth) => auth.companyHaveAssignedESG,
          topBar: {
            title: 18401,
            icon: MainMenuIcons.Statistics_White
          },
          menu: {
            order: 15,
            title: 18401,
            icon: MainMenuIcons.Statistics_Black
          }
        }
      ]
    },
    {
      path: '*',
      component: NoMatch
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/routes.js